import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { ToggleFeature, features } from 'features/ToggleFeature'

import { Button } from 'loyal-react'
import SummaryPlaceholder from './SummaryPlaceholder'
import { CurrencyLabel } from 'Shared/CurrencyLabel'
import CashBack from 'features/CashBack/CashBack'

import {
  SummaryOrder,
  TotalValue,
  TotalPointsCash,
  TotalCashOnly,
  SubmitButton
} from '../../SummaryOrder'

import SecondFactorAuthentication from '../SecondFactorAuthenticaton/SecondFactorAuthentication'

class Summary extends Component {
  state = { showModal: false, hideModal: true, placeholder: true }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  isButtonDisabled = () => {
    const { paymentSelected, creditCard, shipping } = this.props
    if (paymentSelected === 'POINTS_CASH' || paymentSelected === 'CASH_ONLY') {
      const { number, personName, validityDate, cvv } = creditCard
      const installmentSelected = this.props.installmentSelected()
      const parcel = installmentSelected && installmentSelected.parcel
      const brand = this.props.cardBrand()

      return (
        !parcel || !number || !personName || !validityDate || !cvv || !brand
      )
    } else if (paymentSelected === 'POINTS_ONLY') {
      if (shipping.error_get_shipping) {
        return true
      } else {
        return false
      }
    }
    return true
  }

getDifValue = () => {
  const valueInstallment = this.props.installmentSelected()
  if (this.props.paymentSelected === 'CASH_ONLY' && valueInstallment && valueInstallment.parcel && valueInstallment.parcelValue) {
    return (
      <Fragment>
        <div className='row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3'>
          <div className='txt-body-sm color-ui-2 col-6 txt-title-3 txt-font-body txt-left justify-content-center align-self-center'>
            Você pagará:
          </div>
          <div className='txt-body txt-initial color-ui-2 col-6 txt-title-3 txt-subtitle txt-font-body txt-font-body-bold txt-right justify-content-center align-self-center'>
            {valueInstallment.parcel} x <CurrencyLabel id={'valor-parcelas'}
              value={Math.abs(valueInstallment.parcelValue)}
              prefixLabel='R$ '
              decimalPlaces={2}
              className={`txt-initial`}
              showpointsName={false} />
          </div>
        </div>
      </Fragment>
    )
  }
  return ''
}

render () {
  const paymentStep = 2

  const { payment } = this.props
  const {
    isLoading
  } = payment.pointsCashConfig

  if (isLoading && this.props.step === paymentStep) return <SummaryPlaceholder />

  if (this.props.step !== paymentStep) {
    return (
      <SummaryOrder cart={this.props.cart}>
        <TotalValue totalPrice={this.props.totalPrice} />
        { this.props.paymentSelected === 'CASH_ONLY'
          ? <CashBack className='box-cashback row pt-1 mt-1 px-2 border-top border-color-ui-4' price={this.props.cart && this.props.cart.priceCash} />
          : '' }
      </SummaryOrder>
    )
  }
  return (
    <SummaryOrder currentPrice={this.props.currentPrice} cart={this.props.cart}>
      {!this.props.onlyCash && <ToggleFeature feature={features.CupomFeature} />}
      {this.props.paymentSelected === 'POINTS_CASH' ? (
        <TotalPointsCash
          paymentPoints={this.props.paymentPoints}
          installmentSelected={this.props.installmentSelected}
        />
      ) : this.props.paymentSelected === 'CASH_ONLY' ? (
        <div className='d-block'>
          { this.getDifValue() }
          <TotalCashOnly cart={this.props.cart} installmentSelected={this.props.installmentSelected} price={this.props.totalPrice && this.props.totalPrice.cash} />
        </div>
      ) : (
        <TotalValue totalPrice={this.props.totalPrice} />
      )}

      <div className='d-block'>
        <SubmitButton
          text={this.props.onlyCash ? 'FINALIZAR AGORA' : 'FINALIZAR RESGATE'}
          onClick={(e) => {
            this.props.createPurchase()
            window._etmc.push(['setOrgId', '6422293'])
            window._etmc.push(['trackConversion', { 'cart': this.props.cart.items }])
            e.target.blur()
            setTimeout(() => {
              if (document.querySelector('#alert-message-box')) {
                document.querySelector('#alert-message-box').focus()
              }
            }, 300)
          }}
          loading={this.props.isCreatingPurchase}
          disabled={this.isButtonDisabled()}
        />
      </div>

      <div className='float-button bg-white px-2 py-2 row mx-0 d-none'>
        <div className='col-12 mx-0 px-0 row'>
          <p className='col-12 px-0 txt-body-sm color-ui-2 txt-font-body txt-left justify-content-center align-self-center'>
            {this.props.cart.count > 1 ? 'Itens ' : 'Item '}(
            {this.props.cart.count}) + frete
          </p>
        </div>
        <div className='col-12 mx-0 px-0 mb-1 mb-md-0 row'>
          <p className='col-12 px-0 txt-body-sm color-brand-1 txt-font-body txt-left justify-content-center align-self-center'>
            {this.props.paymentSelected === 'POINTS_CASH'
              ? (
                <TotalPointsCash
                  paymentPoints={this.props.paymentPoints}
                  installmentSelected={this.props.installmentSelected}
                  isMobile
                />
              )
              : <TotalValue totalPrice={this.props.totalPrice} isMobile />}
          </p>
        </div>

        <div className='col-12 px-0'>
          <Button
            className='btn btn-sm btn-featured nowrap txt-center'
            text={this.props.onlyCash ? 'FINALIZAR AGORA' : 'FINALIZAR RESGATE'}
            onClick={(e) => {
              this.props.createPurchase()
              window._etmc.push(['setOrgId', '6422293'])
              window._etmc.push(['trackConversion', { 'cart': this.props.cart.items }])

              e.target.blur()

              setTimeout(() => {
                if (document.querySelector('#alert-message-box')) {
                  document.querySelector('#alert-message-box').focus()
                }
              }, 300)

              this.props.createPurchase()
            }}
            loading={this.props.isCreatingPurchase}
            disabled={this.isButtonDisabled()}
          />
        </div>
      </div>
      <div className='modalConfirmationVoucher'>
        <SecondFactorAuthentication
          show={this.state.showModal}
          onClose={() => this.toogleModal()}
          onCloseButton={this.props.createPurchase}
          {...this.props}
        />
      </div>
    </SummaryOrder>
  )
}
}

Summary.propTypes = {
  step: PropTypes.number.isRequired,
  totalPrice: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  createPurchase: PropTypes.func.isRequired,
  paymentSelected: PropTypes.string.isRequired,
  paymentPoints: PropTypes.number.isRequired,
  isCreatingPurchase: PropTypes.bool,
  installmentSelected: PropTypes.func.isRequired,
  creditCard: PropTypes.object,
  cardBrand: PropTypes.func,
  catalog: PropTypes.object,
  onlyCash: PropTypes.bool,
  shipping: PropTypes.object,
  participant: PropTypes.object,
  hasError: PropTypes.bool,
  isAbilityInCampaing: PropTypes.bool,
  payment: PropTypes.object,
  currentPrice: PropTypes.object
}

export default Summary



// WEBPACK FOOTER //
// ./src/features/Checkout/Summary/Summary.js